import { ProductType } from '@tink/core/src/types';
import { MarketCode } from '@tink/config/src/markets';
import { messages as consentMessages } from '../../../components/screens/molecules/SubmitCredentialsScreen/screens/ConsentScreen/messages';
import { commonMessages } from '../../../components/atoms/CommonMessages/messages';

export const bankingConsentProductTypes = [
  ProductType.INCOME_CHECK,
  ProductType.ACCOUNT_CHECK,
  ProductType.EXPENSE_CHECK,
  ProductType.TRANSACTIONS,
  ProductType.REPORTS,
  ProductType.RISK_INSIGHTS,
  ProductType.PRODUCTS,
  ProductType.BUSINESS_ACCOUNT_CHECK,
  ProductType.BUSINESS_TRANSACTIONS,
  ProductType.AUTHORIZE,
];

export const getConsentTitle = (productType: ProductType) => {
  const { riskConsentFinancesTitle, riskConsentTitle } = consentMessages;

  if (
    productType === ProductType.INCOME_CHECK ||
    productType === ProductType.EXPENSE_CHECK ||
    productType === ProductType.REPORTS ||
    productType === ProductType.RISK_INSIGHTS ||
    productType === ProductType.PRODUCTS
  ) {
    return riskConsentFinancesTitle;
  }

  return riskConsentTitle;
};

export const getConsentDetails = (market: MarketCode) => {
  const { riskConsentFinancesDetails, riskConsentDetails } = consentMessages;

  if (market === MarketCode.US) {
    return riskConsentDetails;
  }

  return riskConsentFinancesDetails;
};

export const getRiskConsentTermsAndConditions = (market: MarketCode) => {
  const { riskConsentTermsAndConditions, riskConsentTermsAndConditionsDefault } = consentMessages;

  if (market === MarketCode.US) {
    return riskConsentTermsAndConditions;
  }

  return riskConsentTermsAndConditionsDefault;
};

export const getConsentButtonText = (market: MarketCode) => {
  const continueText = commonMessages.continue;
  const agreeText = commonMessages.agree;

  if (market === MarketCode.US) {
    return agreeText;
  }

  return continueText;
};
